import { render } from "./Mob.vue?vue&type=template&id=43764a92"
import script from "./Mob.vue?vue&type=script&lang=js"
export * from "./Mob.vue?vue&type=script&lang=js"
script.render = render

export default script